import React, { useState } from 'react';
import TiersComponent from '../Tiers/TiersComponent';
import httpService from '../../services/httpService';
import { ApiEndpoints } from '../../constants/appConstants';
import StandardsComponent from '../Standards/StandardsComponent';
import PerformanceAreaComponent from '../PerformanceArea/PerformanceAreaComponent';


import MeasureComponent from '../MeasureComponent/MeasureComponent';
import SmaComponent from '../SmaComponent/SmaComponent';
import ReviewStatusComponent from '../ReviewStatus/ReviewStatusComponent';
import QuestionsComponent from '../Questions/QuestionsComponent';
import ReviewConfigurationComponent from './ReviewConfigurationComponent';

const DataManagementComponent: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [providerTypes, setProviderTypes] = React.useState<{ label: string; value: string }[]>([]);

  React.useEffect(() => {
    httpService.get(ApiEndpoints.GetProviderTypes).then((resp: any) => {
      const pbcOptions = resp?.data.map((type: any) => ({ label: type.providerType || type, value: type.providerCode || type }));
      setProviderTypes(pbcOptions);
    }).catch((error: any) => {
      console.log("Error fetching provider types: ", error);
    });
  }, []);

  const tabList = [
    { label: 'Review Configurations', component: <ReviewConfigurationComponent /> },
    { label: 'Tiers', component: <TiersComponent providerTypes={providerTypes} /> },
    { label: 'Measures', component: <MeasureComponent providerTypes={providerTypes} /> },
    { label: 'Performance Areas', component: <PerformanceAreaComponent providerTypes={providerTypes} /> },
    { label: 'Standards', component: <StandardsComponent providerTypes={providerTypes}/> },
    { label: 'Measure Mapping', component: <SmaComponent providerTypes={providerTypes} /> },
    { label: 'Review Status', component: <ReviewStatusComponent providerTypes={providerTypes} /> },
    { label: 'Questions', component: <QuestionsComponent providerTypes={providerTypes} /> },
  ];

  return (
    <>
      <style>{`
        .dm-tabs {
          display: flex;
          flex-wrap: wrap;
          gap: 4px;
          margin-bottom: 16px;
        }
        .dm-tab-btn {
          flex: 0 0 auto;
          padding: 10px 24px;
          border: none;
          border-bottom: 4px solid transparent;
          background: #f8f8f8;
          color: #222;
          font-weight: 500;
          border-radius: 6px 6px 0 0;
          cursor: pointer;
          white-space: nowrap;
          font-size: 14px;
          transition: background 0.2s, color 0.2s;
          outline: none;
        }
        .dm-tab-btn.dm-tab-active {
          background: #21921c;
          color: #fff;
          font-weight: 700;
          border-bottom: 4px solid #21921c;
          box-shadow: 0 2px 8px rgba(33,146,28,0.12);
        }
        @media (max-width: 900px) {
          .dm-tab-btn {
            flex: 1 1 140px;
            text-align: center;
          }
        }
        @media (max-width: 600px) {
          .dm-tab-btn {
            flex: 1 1 100px;
            padding: 8px 12px;
            font-size: 12px;
            text-align: center;
          }
        }
      `}</style>
      <div className="dm-tabs">
        {tabList.map((tab, idx) => (
          <button
            key={tab.label}
            onClick={() => setActiveIndex(idx)}
            className={`dm-tab-btn${activeIndex === idx ? ' dm-tab-active' : ''}`}
            aria-selected={activeIndex === idx}
            aria-controls={`tabpanel-${idx}`}
            tabIndex={activeIndex === idx ? 0 : -1}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div id={`tabpanel-${activeIndex}`} role="tabpanel" style={{ width: '100%' }}>
        {tabList[activeIndex].component}
      </div>
    </>
  );
};

export default DataManagementComponent;
